angular.module("digiexam.node", [
	"dx.webapp.roles",
	"digiexam.services",
]);
